import { render, staticRenderFns } from "./SendThisCruiseModal.vue?vue&type=template&id=1b1f2bec&scoped=true"
import script from "./SendThisCruiseModal.vue?vue&type=script&lang=js"
export * from "./SendThisCruiseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1f2bec",
  null
  
)

export default component.exports